const validateEmail = (email: string) => {
  const regex = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  return regex.test(email);
};

export default validateEmail;
